import Vue from 'vue'
import Vuex from 'vuex'

import login from "@/store/modules/login"
import layout from "@/store/modules/layout";
import alert from "@/store/modules/alert";

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

const plugins = [
    createPersistedState({
        paths: ["login", "layout", "alert"],
        storage: window.sessionStorage
    })
]
export default new Vuex.Store({
    modules: {
        login,
        layout,
        alert
    },
    plugins
});